import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";

import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import store from "./redux/store";

// ✅ Google OAuth
import { GoogleOAuthProvider } from "@react-oauth/google";

// Make sure you have this in your .env file:
// REACT_APP_GOOGLE_CLIENT_ID=your_google_client_id_here
const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <GoogleOAuthProvider clientId={googleClientId}>
        <App />
        {/* ✅ Toast notifications container */}
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnHover
          draggable
          theme="colored"
        />
      </GoogleOAuthProvider>
    </Provider>
  </React.StrictMode>
);
